<div class="ir-plugin th-plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div class="ir-btn" *ngIf="showHelpButton" [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()">
        <span>?</span>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getAddRoute()">
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.add-attachements.attachements' | translate }}<strong></strong></span>
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data">
          <div *ngFor="let message of messages">
            <span innerHtml="{{ message | translate : { value: plugin } }}"></span>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table *ngIf="assets?.length" class="ir-plugin-table">
      <tr>
        <td style="width: 50%">
          <span>
            <strong>{{ 'plugins.attachements.file-title' | translate }}</strong>
          </span>
        </td>
        <td>
          <span>
            <strong>{{ 'plugins.attachements.file-name' | translate }}</strong>
          </span>
        </td>
      </tr>
      <tr *ngFor="let asset of assets">
        <td>
          <span>{{ asset.FileTitle || asset.Name }}</span>
        </td>
        <td>
          <span>
            <a style="color: black" [attr.href]="getAssetUrl(asset)" target="_blank">
              <strong>{{ asset.Name }}</strong>
            </a>
          </span>
        </td>
      </tr>
    </table>
  </div>
</div>
